import React from 'react';
import InlineField from './InlineField';

export default function AgendaHoursCell({ className = '', rows = [] }) {
  return (
    <div className={`ag-hours-cell ${className}`.trim()}>
      {rows.map(row => (
        <div
          key={row.key}
          className={`ag-hour-row ag-hour-row--${row.key}`}
          onClick={row.canEdit ? () => row.tabGroup?.current?.[row.tabIndex]?.() : undefined}
          style={{ cursor: row.canEdit ? 'text' : undefined }}
        >
          <span className="ag-hour-label">{row.label}</span>
          {row.renderValue ? row.renderValue() : (
            <InlineField
              value={row.value}
              onSave={row.onSave}
              canEdit={row.canEdit}
              mono
              tabGroup={row.tabGroup}
              tabIndex={row.tabIndex}
              placeholder={row.placeholder || '—'}
            />
          )}
        </div>
      ))}
    </div>
  );
}
